import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import type { Language } from '../../components/email-referrals-logo/email-referrals-logo.component';
import { EmailReferralsLogoComponent } from '../../components/email-referrals-logo/email-referrals-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';
import { MailgunMarkAsHtmlPipe } from '../../pipes/mailgun-mark-as-html.pipe';

@Component({
  selector: 'email-referral-email-confirmation-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './referral-email-confirmation.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailReferralsLogoComponent,
    MailgunMarkAsHtmlPipe,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class ReferralEmailConfirmationTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<ReferralEmailConfirmationTemplateData>;
}

export type ReferralEmailConfirmationTemplateData = {
  title: string;
  p1: string;
  button_link: string;
  button_text: string;
  p2_html: string;
  p3: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
  language: Language;
  slogan: string;
};

export const ReferralEmailConfirmationTemplateMocks: ReferralEmailConfirmationTemplateData[] = [
  {
    title: 'Hello Jane 👋',
    p1: "Please click the link below to verify your account and start using ACME's referral portal",
    button_link: 'http://recruitee.com',
    button_text: 'Verify account now',
    slogan:
      'Discover your company’s open jobs, refer friends, and collect rewards if they get hired – all in one place.',
    p2_html:
      'Alternatively click this link: </br><a href="http://recruitee.com">http://recruitee.com</a>',
    p3: "If you weren't expecting this email, feel free to ignore it",
    footer: {
      text: 'Need help?',
      label: 'Contact us',
      href: 'https://auth.recruitee.com/?intercom_open=true',
      target: '_blank',
    },
    language: {
      en: true,
      de: false,
      fr: false,
      nl: false,
      sv: false,
      fi: false,
    },
  },
];
